import React from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import DatasourceBaseOauth from "../Datasources/DatasourceBaseOauth.jsx";


const DatasourceSmartWeLIVE = (props) => {

    const AuthUrl = "https://login.smartwe.de/identity/oauth/auth?response_type=code&client_id=cloud-cti-dec72b1e-166b-4625-8478-42b3c20f7bef.smartwe.de&redirect_uri=https://auth.cloudcti.nl/webapi/oauth2&scope=api.full"
    const TokenUrl = "https://login.SmartWe.de/identity/oauth/token?grant_type=authorization_code&client_id=cloud-cti-dec72b1e-166b-4625-8478-42b3c20f7bef.smartwe.de&client_secret=a46uJ60818Iysw5yVT9vjczGjvTwS5Kw&code="
    const TokenBody = "" 
    const TokenBodyType = "application/x-www-form-urlencoded"
    const TokenCodeInBody = false
    
    return (<DatasourceBaseOauth SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} AuthUrl={AuthUrl} TokenUrl={TokenUrl} TokenBody={TokenBody} TokenBodyType={TokenBodyType} TokenCodeInBody={TokenCodeInBody} OnSetReady={props.OnSetReady}/>)

}

DatasourceSmartWeLIVE.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceSmartWeLIVE